import {
  SheetTrigger,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetFooter,
  Sheet as ShadSheet,
} from '@consigli/shadcn';

import { SheetProps } from './types';

export const Sheet = ({
  isOpen,
  handleOpenChange,
  trigger,
  side,
  className,
  title,
  description,
  children,
  footer,
}: SheetProps) => {
  return (
    <ShadSheet open={isOpen} onOpenChange={handleOpenChange}>
      <SheetTrigger asChild>{trigger}</SheetTrigger>
      <SheetContent side={side} className={className}>
        <SheetHeader>
          <SheetTitle className="text-2xl font-semibold">{title}</SheetTitle>
          {description && <SheetDescription>{description}</SheetDescription>}
        </SheetHeader>

        <div className="flex-1 overflow-y-auto px-4 py-4">{children}</div>

        <SheetFooter className="flex flex-row justify-end space-x-3 pt-4 border-t border-gray-200">
          {footer}
        </SheetFooter>
      </SheetContent>
    </ShadSheet>
  );
};
